const ACTION_KEY = 'VISIT_DETAIL';

const initialState = () => ({
  loading: false,
  visitData: null,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        visitData: action.payload,
        loadedData: newData,
        filter: {
          ...state.filter,
          data: newData
        }
      };
    }
    default:
      return state;
  }
};

export default reducer;
